import { render, staticRenderFns } from "./miniproSetting.vue?vue&type=template&id=35023a5c&scoped=true&"
import script from "./miniproSetting.vue?vue&type=script&lang=js&"
export * from "./miniproSetting.vue?vue&type=script&lang=js&"
import style0 from "./miniproSetting.vue?vue&type=style&index=0&id=35023a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35023a5c",
  null
  
)

export default component.exports